import '@/globals';
import Application from '@components/Application';

const application = new Application();
application.init(); // application form section specific things

